<template>
    <div>
      <v-list-group
        v-if="item.items || item.subItems"
        :value="false"
        :prepend-icon="item.icon"
        :sub-group="depth > 0"
        :disabled="item.disabled"
      >
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </template>
  
        <recursive-menu-item
          v-for="(child, index) in item.items || item.subItems"
          :key="index"
          :item="child"
          :depth="depth + 1"
        ></recursive-menu-item>
      </v-list-group>
  
      <v-list-item v-else :to="item.route" link :disable="item.disabled" >
        <v-list-item-icon v-if="item.icon" class="pl-3">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
        <v-list-item-content >
          
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>
        
        
      </v-list-item>
    </div>
  </template>
  
  <script>
  export default {
    name: 'RecursiveMenuItem',
    props: {
      item: {
        type: Object,
        required: true
      },
      depth: {
        type: Number,
        default: 0
      }
    }
  }
  </script>
<!-- <template>
    <div>
      <v-list-group
        v-if="item.items || item.subItems"
        :prepend-icon="item.icon"
        :value="item.active"
      >
        <template v-slot:activator>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </template>
  
        <recursive-menu-item
          v-for="(child, index) in item.items || item.subItems"
          :key="index"
          :item="child"
        ></recursive-menu-item>
      </v-list-group>
  
      <v-list-item v-else :to="item.route">
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ item.title }}</v-list-item-title>
      </v-list-item>
    </div>
  </template>
  
  <script>
  export default {
    name: 'RecursiveMenuItem',
    props: {
      item: {
        type: Object,
        required: true
      }
    }
  }
  </script> -->
